export default __webpack_public_path__ + "static/media/photo--lg--mike.5d84ce83.jpg";